// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/auth/sign-in/:sign-in*?\",\"regex\":\"^/auth/sign-in(?:/(.*))?$\",\"paramNames\":[\"sign-in\"]},{\"path\":\"/auth/sign-up/:sign-up*?\",\"regex\":\"^/auth/sign-up(?:/(.*))?$\",\"paramNames\":[\"sign-up\"]},{\"path\":\"/login/:rest*?\",\"regex\":\"^/login(?:/(.*))?$\",\"paramNames\":[\"rest\"]}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/privacy\"},{\"path\":\"/terms\"}]}";import * as Sentry from '@sentry/nextjs';

Sentry.init({
	// Setting this option to true will print useful information to the console while you're setting up Sentry.
	debug: false,

	dsn: 'https://5ef39dc81d541d696a84842ee78934d2@o4509207238934528.ingest.de.sentry.io/4509207996596304',

	// Add optional integrations for additional features
	integrations: [Sentry.replayIntegration()],

	// Define how likely Replay events are sampled when an error occurs.
	replaysOnErrorSampleRate: 1.0,

	// Define how likely Replay events are sampled.
	// This sets the sample rate to be 10%. You may want this to be 100% while
	// in development and sample at a lower rate in production
	replaysSessionSampleRate: 0.1,

	// Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
	tracesSampleRate: 1,
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
